// Dýško pro tým v košíku (krok 1)
// Dýško je skutečná položka košíku (skrytý produkt) a v tabulce položek je vidět,
// takže u něj zákazník může zvýšit množství. Volba v sekci je aktivní, dokud je dýško
// v košíku. Najednou nejvýš jedna částka — jiná částka tu předchozí nahradí.

let cartTipQueue = [];
let cartTipBusy = false;
let cartTipSafety = null;
let cartTipStepDone = false;

function getCartTipConfig() {
    const config = window.shopDataLayer && window.shopDataLayer.cartTip;

    if (!config || !config.options || config.options.length === 0) {
        return null;
    }

    return config;
}

function getCartTipCodes(config) {
    return config.options.map(function (option) {
        return String(option.code);
    });
}

// Obsah košíku čteme z vykreslených řádků — po každém AJAX překreslení odpovídají serveru
function getCartTipRows(config) {
    const codes = getCartTipCodes(config);
    const items = [];

    $(".id--9 .cart-table tr.removeable[data-micro-sku]").each(function () {
        const $form = $(this).find("form[action*='deleteCartItem']");

        items.push({
            code: String($(this).attr("data-micro-sku")),
            isTip: codes.includes(String($(this).attr("data-micro-sku"))),
            itemId: $form.find("input[name='itemId']").val(),
            priceId: $form.find("input[name='priceId']").val(),
            $row: $(this),
        });
    });

    return items;
}

function setCartTipBusy(state) {
    cartTipBusy = state;
    clearTimeout(cartTipSafety);

    if (state) {
        // Pojistka, kdyby Shoptet požadavek nedokončil a nevyslal událost
        cartTipSafety = setTimeout(function () {
            cartTipQueue = [];
            setCartTipBusy(false);
            renderCartTip();
        }, 15000);
    }

    $(".mycart-tip").toggleClass("is-loading", state);
    $(".mycart-tip-option").prop("disabled", state);
}

function runCartTipStep() {
    const step = cartTipQueue.shift();

    if (!step) {
        setCartTipBusy(false);
        return;
    }

    cartTipStepDone = false;
    setCartTipBusy(true);
    step();
}

function removeCartTipItem(item) {
    return function () {
        shoptet.cartShared.removeFromCart({ itemId: item.itemId, priceId: item.priceId, amount: 1 }, true);
    };
}

function addCartTipItem(code) {
    return function () {
        shoptet.cartShared.addToCart({ productCode: code }, true);
    };
}

function renderCartTip() {
    const config = getCartTipConfig();
    const $table = $(".id--9 .cart-table");

    if (!config || $table.length === 0) {
        return;
    }

    const items = getCartTipRows(config);
    const tips = items.filter(function (item) {
        return item.isTip;
    });
    const products = items.filter(function (item) {
        return !item.isTip;
    });

    // Řádek dýška zůstává vidět (kvůli množství), jen bez dostupnosti
    tips.forEach(function (item) {
        item.$row.addClass("mycart-tip-row");
    });

    // V košíku zbylo jen dýško → odebrat ho a sekci nezobrazovat
    if (products.length === 0) {
        $(".mycart-tip").remove();

        if (tips.length && !cartTipBusy) {
            cartTipQueue = tips.map(removeCartTipItem);
            runCartTipStep();
        }
        return;
    }

    if ($(".mycart-tip").length === 0) {
        const $tip = $("<div class='mycart-tip'>" +
            "<h2 class='mycart-tip-title'>" + config.title + "</h2>" +
            "<p class='mycart-tip-subtitle'>" + config.subtitle + "</p>" +
            "<div class='mycart-tip-options'></div>" +
        "</div>");

        config.options.forEach(function (option) {
            $("<button type='button' class='mycart-tip-option' data-code='" + option.code + "' aria-pressed='false'>" +
                "<img class='mycart-tip-option-image' src='" + option.image + "' alt='' width='60' height='60'>" +
                "<span class='mycart-tip-option-label'>" + option.label + "</span>" +
            "</button>").appendTo($tip.find(".mycart-tip-options"));
        });

        $tip.insertAfter($table);
    }

    const activeCodes = tips.map(function (item) {
        return item.code;
    });

    config.options.forEach(function (option) {
        const isActive = activeCodes.includes(String(option.code));
        const $option = $(".mycart-tip-option[data-code='" + option.code + "']");

        $option
            .toggleClass("is-active", isActive)
            .attr("aria-pressed", isActive ? "true" : "false")
            .attr("title", isActive ? config.removeTitle : null);
        $option.find(".mycart-tip-option-label").html(isActive && option.activeLabel ? option.activeLabel : option.label);
    });

    $(".mycart-tip").toggleClass("is-loading", cartTipBusy);
    $(".mycart-tip-option").prop("disabled", cartTipBusy);
}

$(document).on("click", ".mycart-tip-option", function (e) {
    e.preventDefault();

    const config = getCartTipConfig();

    if (!config || cartTipBusy) {
        return;
    }

    const code = String($(this).attr("data-code"));
    const tips = getCartTipRows(config).filter(function (item) {
        return item.isTip;
    });
    const isOnlyActive = tips.length === 1 && tips[0].code === code;

    // Klik na aktivní částku = zrušit; jinak odebrat všechna dýška a přidat nové
    cartTipQueue = tips.map(removeCartTipItem);

    if (!isOnlyActive) {
        cartTipQueue.push(addCartTipItem(code));
    }

    runCartTipStep();
});

$(document).ready(function () {
    renderCartTip();
});

// Shoptet po přidání/odebrání vyšle nejdřív událost akce, pak překreslí obsah košíku
["ShoptetCartAddCartItem", "ShoptetCartDeleteCartItem"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
        if (cartTipBusy) {
            cartTipStepDone = true;
        }
    });
});

// Po každé změně košíku (množství, odebrání, přidání, kupón) Shoptet překreslí obsah a vyšle tuto událost
document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    // Dokončený krok naší fronty → spustit další (nebo odemknout), až pak vykreslit.
    // Překreslení od jiné akce (např. změna množství) frontu neposouvá.
    if (cartTipBusy && cartTipStepDone) {
        runCartTipStep();
    }

    renderCartTip();
});

document.addEventListener("ShoptetCartAddCartItemFailed", function () {
    cartTipQueue = [];
    setCartTipBusy(false);
    renderCartTip();
});
